import { Editor as TinyMCEEditor } from 'tinymce';
import {
  removeAttributes,
  removeHtmlComments,
  removeHtmlDirectives,
  removePopupImageFragments,
  removeSearchListTable,
} from '../../../../../../lib/HtmlSanitization/htmlSanitization';
import { normalizeHtml } from '../../../../../../lib/Pipes/pipes';

import { removeControlCharacters } from '../../../../../../_lib/StringUtils';
import { cheerioLoad } from '../../../../../../lib/cheerio/cheerio';
import { LinkchooserLinkType } from '../../../../../../types/api/LinkchooserLinkType';

// safe list is defined in several places:
// - tinyConfiguration.js
// - de.bund.officenet.keycloak.themeConfigSpi.SpiHtmlFeatureSet
// - de.bund.officenet.son.service.validation.SonHtmlFeatureSet
export const approvedDataAttributes = [
  'data-resource-reference',
  'data-breed',
  'data-link-type',
  'data-file-size',
  'data-anchor',
  'data-forecolor',
  'data-hint-language-key',
  'aria-describedby',
];

const attributesToBeRemoved = ['data', 'aria'];

export function pastePreprocess(plugin: any, args: any) {
  /* Overwrite args.content as suggested in the tiny mce documentation
   * (https://www.tiny.cloud/docs/plugins/paste/#paste_preprocess) */

  args.content = removeControlCharacters(
    normalizeHtml(
      args.content,
      removeHtmlComments,
      removeHtmlDirectives,
      removeSearchListTable,
      removePopupImageFragments,
      removeAttributes(attributesToBeRemoved, approvedDataAttributes)
    )
  );
}

/**
 * some custom data-* attributes will not be removed
 *  -> see https://github.com/tinymce/tinymce/blob/develop/modules/tinymce/CHANGELOG.md#fixed-2
 */
function cleanCustomAttributesOnPostProcess(html: HTMLHtmlElement): void {
  html.querySelectorAll('[data-forecolor]').forEach(element => element.removeAttribute('data-forecolor'));
}

/**
 * tiny does not remove aria-label ( or i think any aria-* ) attribute when saving, although
 * we do not define them in valid_elements list -> see github.com/tinymce/tinymce/issues/8515
 * so we clean them when copying from somewhere
 */
function cleanAriaLabelsOnLists(html: HTMLHtmlElement): void {
  const selectors = ['ul[aria-label]', 'ol[aria-label]', 'li[aria-label]'].join(', ');
  html.querySelectorAll(selectors).forEach(element => element.removeAttribute('aria-label'));
}

/**
 * clean on paste.
 * tiny already transforms the pasted text to html here, so we dont need cheerio !
 */
export function pastePostProcess(editor: any, args: any): void {
  const html = args.node as HTMLHtmlElement;
  cleanCustomAttributesOnPostProcess(html);
  cleanAriaLabelsOnLists(html);
}

export const getTextContent = (editorInstance: TinyMCEEditor | null): string => {
  return editorInstance ? editorInstance.getContent({ format: 'html' }) : '';
};

export function convertAttachmentLinkHtmlString(html: string) {
  // isDocument parameter of cheerio load is set to false as to avoid body, head and other tags being added by cheerio
  const $ = cheerioLoad(html);

  $('a').each((_, element) => {
    if (
      element.attribs['data-breed'] === LinkchooserLinkType.Attachment ||
      element.attribs['data-link-type'] === LinkchooserLinkType.Attachment
    ) {
      $(element)
        .removeAttr('class data-reactroot')
        .find('span')
        .each((i: number, e) => {
          // @ts-expect-error as firstChild exists
          let linkContent = e.firstChild.data;

          if (linkContent.endsWith('(')) {
            linkContent = linkContent.replace('(', '').trim();
          }

          $(e).replaceWith(linkContent);
        });
    }
  });

  return $.html().replace(/&nbsp;/gm, ' ');
}
